import Masonry from "masonry-layout";

(function () {
  document.querySelectorAll('.section-media-grid').forEach(section => {
    const grid = section.querySelector('.grid');
    const items = section.querySelectorAll('.grid-item');

    // 記事グリッド生成
    var msnry = new Masonry(grid, {
      // options...
      itemSelector: '.grid-item',
      columnWidth: '.grid-sizer',
      percentPosition: true,
      transitionDuration: 0,
      // 極力登録順に左から右へ表示
      horizontalOrder: true,
    });

    // リサイズ監視
    const resizeObserver = new ResizeObserver(entries => {
      msnry.layout();
    });

    items.forEach(item => {
      resizeObserver.observe(item);
    });

    setInterval(() => {
      msnry.layout();
    }, 2000);
  });
}());

class MediaGrid extends HTMLElement {
  constructor() {
    super();

    if (!this.classList.contains('delay')) {
      this.init();
    }
  }

  init() {
    const grid = this.querySelector('.grid');
    const items = this.querySelectorAll('.grid-item');

    var msnry = new Masonry(grid, {
      // options...
      itemSelector: '.grid-item',
      columnWidth: '.grid-sizer',
      percentPosition: true,
    });

    const resizeObserver = new ResizeObserver(entries => {
      msnry.layout();
    });

    items.forEach(item => {
      resizeObserver.observe(item);
    });

    // setInterval(() => {
    //     msnry.layout();
    // }, 2000);
  }
}

customElements.define('media-grid', MediaGrid);
